import { render, staticRenderFns } from "./ChartOmoIcon.vue?vue&type=template&id=587ca27b&scoped=true"
import script from "./ChartOmoIcon.vue?vue&type=script&lang=ts"
export * from "./ChartOmoIcon.vue?vue&type=script&lang=ts"
import style0 from "./ChartOmoIcon.vue?vue&type=style&index=0&id=587ca27b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ca27b",
  null
  
)

export default component.exports